module.exports = __webpack_public_path__ + "img/icon_purple_medal.75ddb8ee.png";